import { ChevronRight } from 'components/icons';
import styles from 'styles/components/checkout/caap/rightArrow.scss';

const RightArrow = params => {
  const testId = params['data-test-id'];
  const dataTestId = testId ? { 'data-test-id': testId } : {};

  return (
    <div { ...dataTestId } className={styles.rightArrow}>
      <ChevronRight color="black" size={24}/>
    </div>
  );
};

export default RightArrow;
